// istanbul ignore file
const UNKNOWN_ERROR = 'Unknown error';

const getNestedValue = (obj: Record<string, unknown>, path: string[]): unknown => {
  let current: unknown = obj;
  for (const key of path) {
    if (current && typeof current === 'object' && key in current) {
      current = (current as Record<string, unknown>)[key];
    } else {
      return undefined;
    }
  }
  return current;
};

const extractErrorMessage = (error: unknown): string => {
  if (!error) {
    return UNKNOWN_ERROR;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error !== 'object') {
    return UNKNOWN_ERROR;
  }

  const errorObj = error as Record<string, unknown>;

  const messagePaths = [
    ['response', 'data', 'message'], // HttpError
    ['internalError', 'errorMessage'], // nested internal errors
    ['translatedError'], // translated/user-friendly errors
    ['errorMessage'], // direct errorMessage property
    ['message'], // standard message property
    ['error', 'message'], // nested error.message
    ['error'], // error as string
  ];

  for (const path of messagePaths) {
    const value = getNestedValue(errorObj, path);
    if (value && typeof value === 'string') {
      return value;
    }
  }

  return UNKNOWN_ERROR;
};

export const toMonitorError = (
  error: unknown,
  description?: string
): [Error, {tags: {tagName: string}; context: {fullError: unknown}}] => {
  const extractedMessage = extractErrorMessage(error);
  const errorMessage = `Error: ${extractedMessage}`;
  return [
    new Error(description ? `${description} ${errorMessage}` : errorMessage),
    {
      tags: {tagName: description ?? errorMessage},
      context: {
        fullError: error,
      },
    },
  ];
};
